import Event from '@oppobrowser/lib-browser-event';
import EventEmit from '@oppobrowser/lib-browser-eventEmit';
import template from './index.dot';
import moreIconTemplate from './moreIcon.dot';
import {
  formatTime,
  getIsShowMainAndrelatedNews,
  getPageApp,
  isWallet,
  isPictorial,
} from '../../js/utils';
import {
  browserPartner,
  buuid,
  stat_id,
  channel,
  isNewPush,
  contentTypeMap,
  isSmallRedBook,
  enterId,
  getDetailPageMode,
} from '../../js/constants';
import { fetchRelatedNews } from '../../js/api';
import { commonSdkContentTypeMap } from '../../../config/const';
import {
  getBizTraceInfo,
  getHeaderKKUA,
  bizTraceCacheGet,
  bizTraceCacheSet,
  commonSaveConfig,
} from '@js/native';
import './index.scss';
import { query, getQuery } from '@js/utils';

import wv from '@cpc/lib-browser-jsapi';

// 全局主题色
const globalTheme = window.globalTheme;

const EventHandler = {
  clickRelatedNewsStat(node, event) {
    event.stopPropagation();
    const detailPageMode = getDetailPageMode();
    const index = node.dataset.index;
    const bizTrace = {
      id: node.dataset.transparentid,
      transparent: node.dataset.transparent,
    };
    const item = this.data[index];
    const { sourceVal } = window.store;
    let clickStatData = {
      url: item.url,
      title: item.title,
      type: contentTypeMap[item.contentType] || 'article',
      pos: index,
      DocID: item.id,
      docid: item.id,
      docId: item.id,
      source: sourceVal,
      sourceMedia: item.sourceMedia,
      statId: item.statisticsid,
      buuid:
        (this.session &&
          this.session.data &&
          this.session.data.info &&
          this.session.data.info.buuid) ||
        '',
      eventTime: +new Date(),
      iflowSource: 'OPPO',
      openSource: 'reNews',
      impid: item.statisticsid,
      category: item.category,
      style: item.styleType,
      source_name: item.sourceName,
      stat_id: stat_id,
      push_source:
        channel && isNewPush ? 'push_infinity' : channel ? 'push' : '',
      bizTrace,
      content_style: isSmallRedBook ? 'redbook_style' : 'normal_style',
      enterId,
      detailPageMode,
    };
    // 天气信息流归因字段
    // if (browserPartner == 'weather') {
    clickStatData.bizTraceId = bizTrace.id;
    clickStatData.bizTraceTransparent = bizTrace.transparent;
    // }
    if (this.openSource.includes('assistantscreen')) {
      clickStatData.openSource = 'assistantscreen';
    }
    // 通用信息流新增
    if (window.pageData?.isCommonSdk) {
      clickStatData.topCategory =
        item?.category?.length >= 2 ? item.category[0] : '' || '';
      clickStatData.secondCategory =
        item?.category?.length >= 2 ? item.category[1] : '' || '';
      clickStatData.type =
        commonSdkContentTypeMap[item?.contentType] || 'other';
      clickStatData.mediaName = item?.medium?.name || '';
      clickStatData.mediaId = item?.medium?.mediaId || '';
      clickStatData.sourceDocId = query.get('__docId__') || '';
    }

    console.log('相关新闻点击上报', clickStatData);
    bizTraceCacheSet(item.id, bizTrace);

    // 数据存到客户端
    bizTrace.docid = item.id;
    commonSaveConfig('h5_sdk_bizTrace', bizTrace);

    node.classList.add('news-item__visited');
    wv.onClickRelatedNews && wv.onClickRelatedNews([clickStatData]);

    // 跳转页面-判断锁屏
    const jumpUrl = item[item.contentType === 3 ? 'url' : 'urlWithQuery'];
    if (
      isPictorial() &&
      window.AndroidInterface &&
      window.AndroidInterface.clickAd
    ) {
      window.AndroidInterface.clickAd(jumpUrl);
    } else {
      window.location.href = jumpUrl;
    }
  },

  goMoreRelatedNews(node, event) {
    event.stopPropagation();
    if (window.wv.isMethodValid('BrowserIFlow.jumpToNewsChannel')) {
      window.wv.invoke('BrowserIFlow.jumpToNewsChannel', '6aaW6aG1', '首页');
    }
    if (window.wv.isMethodValid('generalStat')) {
      window.wv.generalStat(20084074, 10012, 21034, JSON.stringify({}));
    }
  },
};

export default class RelatedNews {
  constructor(el, name, data = {}) {
    this.el = el;
    this.data = [];
    this._eventHandler = {};
    this.openSource = '';
    this.bizTraceInfo = bizTraceCacheGet(query.get('__docId__'));
  }

  init() {
    const pageType = process.env.OFET_PAGE_TYPE;
    const { source } = window.store;
    //三方直接返回相关新闻加载完成
    switch (pageType) {
      case 'feednewsThird':
        if (source != 'tencent') {
          EventEmit.instance.emit('component-loaded', 'relatedNews', {
            data: [],
          });
        } else {
          this.initNormal();
        }
        break;
      default:
        this.initNormal();
    }
  }
  initNormal() {
    Object.keys(EventHandler).forEach((fn) => {
      this._eventHandler[fn] = EventHandler[fn].bind(this);
    });
    this._bindEvent();
    this.getData();
    this.openSource = query.get('iflowScene') || '';
  }
  _bindEvent() {
    this._comEvent = new Event('click', this.el);
    this._comEvent.registeHandler(this._eventHandler);
  }

  async getData() {
    //调用客户端方法获取相关搜索查询词
    const { uid, loginUid, uuid, feedssession, sourceVal } = window.store;
    const transparent = getBizTraceInfo?.().transparent;
    const kkua = await getHeaderKKUA();
    const headers = { buuid, ...kkua };
    const isCommonSdk = getQuery('commonFeeds') || 0;
    const data = {
      pageApp: getPageApp(),
      source: sourceVal,
      browserPartner,
    };

    // 通用信息流写死下面1个参数
    if (isCommonSdk) {
      data.useCommonSdk = 1;
    }

    //端外/端内打开页面传值不同
    if (process.env.OFET_PAGE_TYPE !== 'feeds') {
      Object.assign(data, {
        userId: uid || loginUid,
        uuid,
        feedssession,
        bizTraceTransparent:
          this.bizTraceInfo?.value?.transparent || transparent || '',
      });
    }
    const fromId = getQuery('__fromId__') || '';
    fromId && (data.fromId = fromId);
    if (!this.bizTraceInfo?.value?.transparent && transparent) {
      bizTraceCacheSet(query.get('__docId__'), getBizTraceInfo());
    }

    fetchRelatedNews(data, headers)
      .then((data) => {
        this.data = data || [];
        // 测试数据
        // if (env === 'development' && this.data.length === 0) {
        //   this.data = require('./mockRelatedNewsData.js').mockData.data;
        //   console.log('this.data',this.data);
        // }
        this.data = this.data.slice(0, isSmallRedBook ? 3 : 5);
        this.data.forEach((item) => {
          item.formatPublishTime = formatTime(item.publishTime);
          item.urlWithQuery = this.addUrlQuerys(item.url);
          if (this.openSource) {
            item.openSource = 'assistantscreen';
          }
        });
        this.render();
        setTimeout(() => {
          this.exposeRelatedNewsStat(this.data);
        });
      })
      .catch((error) => {
        throw error;
      })
      .finally(() => {
        EventEmit.instance.emit('component-loaded', 'relatedNews', {
          data: this.data,
        });
      });
  }

  exposeRelatedNewsStat(value) {
    const { sourceVal } = window.store;
    let observed = Array.from(
      this.el.querySelectorAll('.news-item:not(.news-item__more)'),
    );

    let io = new IntersectionObserver(function (entries) {
      const detailPageMode = getDetailPageMode();
      entries.forEach((entry) => {
        let index = observed.indexOf(entry.target);
        if (entry && entry.isIntersecting && entry.intersectionRatio > 0) {
          let relatedDetail = value[index];
          let bizTrace = {
            id: entry.target.dataset.transparentid,
            transparent: entry.target.dataset.transparent,
          };

          let exposeStatData = {
            type: contentTypeMap[relatedDetail.contentType] || 'article',
            title: relatedDetail && relatedDetail.title,
            url: relatedDetail.url,
            pos: index,
            DocID: relatedDetail.id,
            docid: relatedDetail.id,
            docId: relatedDetail.id,
            source: sourceVal,
            sourceMedia: relatedDetail.sourceMedia,
            impid: relatedDetail.statisticsid,
            style: relatedDetail.styleType,
            category: relatedDetail.category,
            source_name: relatedDetail.sourceName,
            openSource: relatedDetail.openSource,
            stat_id: stat_id,
            push_source:
              channel && isNewPush ? 'push_infinity' : channel ? 'push' : '',
            bizTrace,
            enterId,
            detailPageMode,
          };
          // 通用信息流新增
          if (window.pageData?.isCommonSdk) {
            exposeStatData.topCategory =
              relatedDetail?.category?.length >= 2
                ? relatedDetail.category[0]
                : '' || '';
            exposeStatData.secondCategory =
              relatedDetail?.category?.length >= 2
                ? relatedDetail.category[1]
                : '' || '';
            exposeStatData.mediaName = relatedDetail?.medium?.name || '';
            exposeStatData.mediaId = relatedDetail?.medium?.mediaId || '';
            exposeStatData.sourceDocId = query.get('__docId__') || '';
            exposeStatData.type =
              commonSdkContentTypeMap[relatedDetail?.contentType] || 'other';
          }

          // 天气信息流归因字段
          // if (browserPartner == 'weather') {
          exposeStatData.bizTraceId = bizTrace.id;
          exposeStatData.bizTraceTransparent = bizTrace.transparent;
          // }
          console.log('相关新闻曝光上报', exposeStatData);

          wv &&
            wv.onRelatedNewsExposured &&
            wv.onRelatedNewsExposured([exposeStatData]);
          io.unobserve(entry.target);
        }
      });
    });

    // IntersectionObserver 的options.threshold 在钱包里面这个会导致IntersectionObserver无效
    observed.forEach((it) => io.observe(it));
  }

  //夜间模式监听
  registerNightModeHandler() {
    this._nightModeHandler();
    window.document.addEventListener('nightmodechange', () => {
      this._nightModeHandler();
    });
  }

  _nightModeHandler() {
    let relatedNews = document.querySelector('.relatedNews');
    let newSmore = document.querySelector('.news-item__more');
    if (window.store.nightMode) {
      relatedNews.classList.add('border-dark');
      if (getIsShowMainAndrelatedNews() && newSmore) {
        newSmore.classList.add('news-item__more__dark');
      }
    } else {
      relatedNews.classList.remove('border-dark');
      if (getIsShowMainAndrelatedNews() && newSmore) {
        newSmore.classList.remove('news-item__more__dark');
      }
    }
  }
  addUrlQuerys(url) {
    const API = (window.oppo && window.oppo.API) || {};
    let queryAccess = API.queryAccess;
    if (queryAccess && Array.isArray(queryAccess) && queryAccess.length > 0) {
      let separator;
      queryAccess.forEach((item) => {
        const val = query.get(item);
        if (val) {
          separator = url.includes('?') ? '&' : '?';
          url = url + separator + item + '=' + val;
        }
      });
    }
    return url;
  }
  fillerData(val) {
    let url = new URL(val);
    let data = url.searchParams.get('__source__');
    if (data === 'oppo') {
      return true;
    }
    return false;
  }

  render() {
    this.data.forEach((item) => {
      try {
        const url = new URL(item.url);
        const urlWithQuery = new URL(item.urlWithQuery);
        if (getIsShowMainAndrelatedNews() && this.fillerData(item.cmtUrl)) {
          url.searchParams.set('iflowScene', 'card_assistantscreen');
          urlWithQuery.searchParams.set('iflowScene', 'card_assistantscreen');
        }
        // 透传 配置参数
        const detailPageConfig = query.get('__detailPageConfig__');
        if (detailPageConfig) {
          url.searchParams.set('__detailPageConfig__', detailPageConfig);
          urlWithQuery.searchParams.set(
            '__detailPageConfig__',
            detailPageConfig,
          );
        }
        if (isWallet()) {
          // 用于新开窗口
          url.searchParams.set('target', '_blank');
          urlWithQuery.searchParams.set('target', '_blank');
        }
        item.url = url.toString();
        item.urlWithQuery = urlWithQuery.toString();
      } catch (error) {
        console.error('relatedNews resolve data error:', error);
      }
    });

    this.el.innerHTML = template({
      dataList: this.data,
      isShow: getIsShowMainAndrelatedNews(),
      isOs13: globalTheme.getColorOsVersion() >= 13,
      moreIcon: moreIconTemplate(),
    });
    this.registerNightModeHandler();
  }
}
